export default {
    pmusers_reset_password: "Restablecer contraseña",
    pmusers_reset_permanent: "Permanente",
    pmusers_passwords_do_not_match: "Las contraseñas no coinciden",
    pmusers_the_password_has_been_reset: "Hemos enviado un enlace para restablecer la contraseña",
    pmusers_reset_password_message: "Se enviará un correo electrónico al usuario con un enlace para restablecer la contraseña",
}